import type { ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { fetchCurrentUser } from "../shared/api";
import { forbiddenHref, hasAnyPermission } from "../shared/config";

/**
 * Chan route KHONG dung ModuleLayout (trang trong ModuleLayout da tu chan qua
 * `routeAccess`). Can BAT KY quyen trong `anyOf` (ho tro `x.*`); superuser / staff
 * luon qua (giong PermissionGuard ben API); `superuserOnly` chi superuser. Khong co → /403 kem
 * ten tinh nang. Dang tai thong tin nguoi dung thi chua ve gi (tranh nhay trang).
 * Day chi la lop giao dien: API van tu chan bang PermissionGuard.
 */
export function RequirePermission({
  anyOf = [],
  superuserOnly = false,
  feature,
  children,
}: {
  anyOf?: readonly string[];
  superuserOnly?: boolean;
  feature: string;
  children: ReactNode;
}) {
  const { data: user, isLoading } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: fetchCurrentUser,
    retry: false,
  });
  if (isLoading) return null;
  // Loi /auth/me (het phien) de nguyen cho luong dang nhap xu ly.
  if (!user) return <>{children}</>;
  const ok = superuserOnly ? user.isSuperuser : hasAnyPermission(user, anyOf);
  if (!ok) return <Navigate to={forbiddenHref(feature)} replace />;
  return <>{children}</>;
}
